module.exports = __webpack_public_path__ + "static/media/9DESA12.2b7af0d7.jpg";